import { keyframes } from "@emotion/react";

const pulseAnimation = keyframes`
  0% {
    box-shadow: 0px 3px 15px 0px rgba(255,255,255, 0.1);
  }
  50% {
    box-shadow: 0px 3px 45px 5px rgba(255,255,255, 0.8);
  },
  100% {
    box-shadow: 0px 0px 0px 0px rgba(255,255,255, 0.1);
  }
`;

const fadeInAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const moveUpAnimation = keyframes`
  0% {
    transform: translateY(200px);
    opacity: 0
  }
  100% {
    transform: translateY(0px);
    opacity: 1
  }
`;


export const animations = {
  pulse: pulseAnimation,
  fadeIn: fadeInAnimation,
  moveUp: moveUpAnimation,
}